(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    if (
      !window.miniCartCanvas &&
      document.querySelector("#mini-cart-offcanvas")
    ) {
      window.miniCartCanvas = new bootstrap.Offcanvas("#mini-cart-offcanvas");
    }

    if (
      typeof window.StickySidebar !== "undefined" &&
      document.querySelector(".cart-summary-column-inner")
    ) {
      new window.StickySidebar(".cart-summary-column-inner", {
        topSpacing: 30,
        bottomSpacing: 30,
        minWidth: 992,
      });
    }
  });

  document.addEventListener("submit", function (e) {
    const form = e.target.closest(".card-add-to-cart form");
    if (form) {
      e.preventDefault();
      const productCard = form.closest(".product-card");
      const parentEl = productCard ? productCard.parentNode : null;
      const item_id = parentEl ? parentEl.id : "";

      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, name) => {
        params.append(name, value);
      });
      params.append("action", "negarshop_add_to_cart_ajax");
      params.append("id", params.get("add-to-cart") || "");
      params.set("add-to-cart", "false");

      form.classList.add("disabled");

      fetch(NS_OBJ.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status !== undefined) {
            if (response.redirect) {
              window.location.href = response.redirect;
              return;
            }

            const offsetVal = form.getAttribute("data-offset")
              ? parseInt(form.getAttribute("data-offset"))
              : 1000;
            if (window.jQuery && typeof window.jQuery.notify === "function") {
              window.jQuery.notify(
                {
                  message: response.message,
                },
                {
                  element: "body",
                  position: null,
                  type: response.style,
                  allow_dismiss: false,
                  newest_on_top: false,
                  placement: {
                    from: "top",
                    align: "right",
                  },
                  z_index: offsetVal,
                  delay: 2000,
                  timer: 1000,
                },
              );
            } else {
              alert(response.message);
            }

            document
              .querySelectorAll(".widget_shopping_cart_content")
              .forEach((el) => {
                el.innerHTML = response.basket;
              });
            document
              .querySelectorAll(
                ".cart-basket-box span.count, #responsive-header .rh-item .badge",
              )
              .forEach((el) => {
                el.textContent = response.count;
              });
            document
              .querySelectorAll(".cart-basket-box span.subtitle")
              .forEach((el) => {
                el.innerHTML = response.total_amount;
              });

            if (
              document.body.classList.contains("auto-open-mini-cart") &&
              window.miniCartCanvas
            ) {
              window.miniCartCanvas.show();
            }
          }

          if (productCard) {
            productCard.classList.remove("show-add-cart");
          }
          form.classList.remove("disabled");
        })
        .catch((err) => {
          console.error(err);
          form.classList.remove("disabled");
        });
    }
  });

  document.addEventListener("click", function (e) {
    const atcBtn = e.target.closest(".cb-add-to-cart:not(.advanced_cart)");
    if (atcBtn) {
      atcBtn.classList.add("disabled");

      const params = new URLSearchParams();
      params.append("action", "negarshop_add_to_cart_ajax");
      params.append("id", atcBtn.getAttribute("data-id") || "");

      fetch(NS_OBJ.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.status !== undefined) {
            if (response.redirect) {
              window.location.href = response.redirect;
              return;
            }

            const offsetVal = atcBtn.getAttribute("data-offset")
              ? parseInt(atcBtn.getAttribute("data-offset"))
              : 1000;
            if (window.jQuery && typeof window.jQuery.notify === "function") {
              window.jQuery.notify(
                {
                  message: response.message,
                },
                {
                  element: "body",
                  position: null,
                  type: response.style,
                  allow_dismiss: false,
                  newest_on_top: false,
                  placement: {
                    from: "top",
                    align: "right",
                  },
                  z_index: offsetVal,
                  delay: 2000,
                  timer: 1000,
                },
              );
            } else {
              alert(response.message);
            }

            document
              .querySelectorAll(".widget_shopping_cart_content")
              .forEach((el) => {
                el.innerHTML = response.basket;
              });
            document
              .querySelectorAll(
                ".cart-basket-box span.count, #responsive-header .rh-item .badge",
              )
              .forEach((el) => {
                el.textContent = response.count;
              });
            document
              .querySelectorAll(".cart-basket-box span.subtitle")
              .forEach((el) => {
                el.innerHTML = response.total_amount;
              });

            if (
              document.body.classList.contains("auto-open-mini-cart") &&
              window.miniCartCanvas
            ) {
              window.miniCartCanvas.show();
            }
            atcBtn.classList.add("added");
          }
          atcBtn.classList.remove("disabled");
        })
        .catch((err) => {
          console.error(err);
          atcBtn.classList.remove("disabled");
        });
      return;
    }

    const miniCartBtn = e.target.closest(
      ".header-cart-basket.cart-mode-popup .cart-basket-box",
    );
    if (miniCartBtn) {
      e.preventDefault();
      if (window.miniCartCanvas) {
        window.miniCartCanvas.show();
      }
      return;
    }

    const applyCouponBtn = e.target.closest(
      '.cart-summary-column .coupon [name="apply_coupon"]',
    );
    if (applyCouponBtn) {
      e.preventDefault();
      const couponWrapper = applyCouponBtn.closest(".coupon");
      const couponInput = couponWrapper
        ? couponWrapper.querySelector('[name="coupon_code"]')
        : null;
      const couponCode = couponInput ? couponInput.value : "";

      const form = document.querySelector("form.woocommerce-cart-form");
      if (form) {
        const targetInput = form.querySelector('[name="coupon_code"]');
        const targetBtn = form.querySelector('[name="apply_coupon"]');
        if (targetInput) targetInput.value = couponCode;
        if (targetBtn) targetBtn.click();
      }
    }
  });

  let cartUpdateTimeout;
  document.addEventListener("change", function (e) {
    const cartForm = e.target.closest(".woocommerce-cart-form");
    if (cartForm) {
      if (cartUpdateTimeout) {
        clearTimeout(cartUpdateTimeout);
      }
      cartUpdateTimeout = setTimeout(() => {
        const updateCartBtn = cartForm.querySelector('[name="update_cart"]');
        if (updateCartBtn) updateCartBtn.click();
      }, 1000);
    }
  });
})();
